import React from 'react';
import { styles } from './CoverImage.css';
import { ContentfulImage, ContentfulImageProps } from '../../ContentfulImage/ContentfulImage';
import { useAspectRatio } from '../../hooks/useAspectRatio/useAspectRatio';
import AspectRatio from '@jbhi-fi/lanyard-ui/components/AspectRatio';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';

export const DEFAULT_CARD_COVER_ASPECT_RATIO = 800 / 345;
export const DEFAULT_VIDEO_CARD_COVER_ASPECT_RATIO = 800 / 450;

export type CoverImageProps = ContentfulImageProps & {
  isVideoCard?: boolean;
  coverImageAspectRatio?: number;
};

export const CoverImage = ({ isVideoCard = false, ...imgProps }: CoverImageProps) => {
  const aspectRatio =
    useAspectRatio() ?? (isVideoCard ? DEFAULT_VIDEO_CARD_COVER_ASPECT_RATIO : DEFAULT_CARD_COVER_ASPECT_RATIO);

  return (
    <AspectRatio ratio={aspectRatio}>
      <ContentfulImage
        {...imgProps}
        aspectRatio={aspectRatio}
        imgOverlay={isVideoCard ? <Icon name="PlayIllustrated" className={styles.playIcon} /> : null}
      />
    </AspectRatio>
  );
};
